export default __webpack_public_path__ + "static/media/city@2x.3334f104.png";